module.exports = __webpack_public_path__ + "media/images/lp_reason-3-10dee7ea6cb9d60755981612517ddd4c.webp";